import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "AR Aging Summary";
const description = `The Purchase By Supplier report is a key procurement document that provides a consolidated overview of a company's purchasing activity, detailing **which products** and **how much** of each product were acquired **from which specific suppliers** over a defined period. This report is essential for **spend analysis**, helping management to track expenditure patterns, identify the total value of business conducted with each vendor, compare prices across different suppliers for the same goods, and ultimately inform strategic decisions related to supplier negotiation, cost reduction, and vendor relationship management.  It clearly synthesizes complex transactional data into a readily understandable format, making it easier to monitor supplier performance and ensure compliance with procurement policies.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const ArAgingSummary: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArAgingSummary;
